module.exports = __webpack_public_path__ + "img/home_turtle_1.70ce43b5.jpg";